import { render } from "./oopsBanner.vue?vue&type=template&id=4405630d&scoped=true"
import script from "./oopsBanner.vue?vue&type=script&lang=js"
export * from "./oopsBanner.vue?vue&type=script&lang=js"

import "./oopsBanner.vue?vue&type=style&index=0&id=4405630d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4405630d"]])

export default __exports__